module.exports = __webpack_public_path__ + "media/images/back-icon-8dea6866.png";